import React from 'react';
import { GatsbyBrowser } from 'gatsby';
import { IntlProvider } from 'react-intl';

import './src/assets/style/style.scss';
import '@formatjs/intl-locale/polyfill';
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/en';

import en from './src/languages/en.json';
const messages = {
	en,
};

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => {
	return (
		<IntlProvider locale="en" messages={messages.en}>
			{element}
		</IntlProvider>
	);
};
